import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

export type M2StaticDatum = {
  id: number;
  name?: string;
  isin?: string;
  code?: string;
  currency?: string;
  asset_class_1?: string;
  asset_class_2?: string;
  ticker?: string;
  custodian?: string;
  custodian_code?: string;
  custodian_code_type?: string;
  custodian_country_code?: string;
  custodian_country_name?: string;
  climate_risk?: string;
  valuation_method?: number;
  shock_type?: string;
};

export const getM2StaticDataColumns = (t: any): ColumnDef<M2StaticDatum>[] => [
  {
    accessorKey: "id",
    header: t("m2_static_data.columns.id", {
      ns: "tables",
      defaultValue: "ID",
    }),
  },
  {
    accessorKey: "name",
    header: t("m2_static_data.columns.name", {
      ns: "tables",
      defaultValue: "Nom",
    }),
  },
  {
    accessorKey: "isin",
    header: t("m2_static_data.columns.isin", {
      ns: "tables",
      defaultValue: "ISIN",
    }),
  },
  {
    accessorKey: "code",
    header: t("m2_static_data.columns.code", {
      ns: "tables",
      defaultValue: "Code",
    }),
  },
  {
    accessorKey: "ticker",
    header: t("m2_static_data.columns.ticker", {
      ns: "tables",
      defaultValue: "Ticker",
    }),
  },
  {
    accessorKey: "currency",
    header: t("m2_static_data.columns.currency", {
      ns: "tables",
      defaultValue: "Devise",
    }),
  },
  {
    accessorKey: "asset_class_1",
    header: t("m2_static_data.columns.asset_class_1", {
      ns: "tables",
      defaultValue: "Classe d'actifs",
    }),
  },
  {
    accessorKey: "asset_class_2",
    header: t("m2_static_data.columns.asset_class_2", {
      ns: "tables",
      defaultValue: "Sous-classe d'actifs",
    }),
  },
  {
    accessorKey: "custodian",
    header: t("m2_static_data.columns.custodian", {
      ns: "tables",
      defaultValue: "Dépositaire",
    }),
  },
  {
    accessorKey: "custodian_code",
    header: t("m2_static_data.columns.custodian_code", {
      ns: "tables",
      defaultValue: "Code dépositaire",
    }),
  },
  {
    accessorKey: "custodian_code_type",
    header: t("m2_static_data.columns.custodian_code_type", {
      ns: "tables",
      defaultValue: "Type de code dépositaire",
    }),
  },
  {
    accessorKey: "custodian_country_name",
    header: t("m2_static_data.columns.custodian_country_code", {
      ns: "tables",
      defaultValue: "Pays du dépositaire",
    }),
  },
  {
    accessorKey: "climate_risk",
    header: t("m2_static_data.columns.climate_risk", {
      ns: "tables",
      defaultValue: "Risque climatique",
    }),
  },
  {
    accessorKey: "valuation_method",
    header: t("m2_static_data.columns.valuation_method", {
      ns: "tables",
      defaultValue: "Méthode de valorisation",
    }),
  },
  {
    accessorKey: "shock_type",
    header: t("m2_static_data.columns.shock_type", {
      ns: "tables",
      defaultValue: "Type de choc",
    }),
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return (
        <div className="flex gap-11 justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
